<template>
	<div
		v-if="!horizontal"
		class="tip"
	>
		<span class="icon"></span>
		<p c class="text">为了获取最佳体验<br />请横屏浏览</p>
	</div>
</template>
<script>
export default {
	created() {
		this.horizontal =
			Math.abs(window.orientation) == 90 ||
			document.body.clientWidth > document.body.clientHeight;
		window.addEventListener(
			"orientationchange",
			() => {
				// console.log(window.orientation);
				// 根据event.orientation|screen.orientation.angle等于0|180、90|-90度来判断横竖屏
				this.horizontal =
					Math.abs(window.orientation) == 90 ||
					document.body.clientWidth > document.body.clientHeight;
			},
			false
		);
		window.addEventListener(
			"resize",
			() => {
				this.horizontal =
					Math.abs(window.orientation) == 90 ||
					document.body.clientWidth > document.body.clientHeight;
			},
			false
		);
	},
	data() {
		return {
			horizontal: false,
		};
	},
};
</script>
<style lang="less" scoped>
.tip {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.95);
	position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #00f6ff;
  font-size: 18px;
  line-height: 1.5;
  .text{
    margin-top: 15px;
  }
  .icon{
    margin-top: -20px;
    display: inline-block;
    width: 136px;
    height: 100px;
    background: url("./horizontal.png") no-repeat center/contain;
  }
}
</style>